export default "__VITE_ASSET__Dz5aoowK__"